module.exports = __webpack_public_path__ + "media/images/service/w_rj-9cf612d6f7cfa530462d6a19f0483e5d.png";